import { UseCase } from '@/shared/application/UseCase';
import { SfApiResponse } from '@hfc/ui-core';
import { SmallBusinessRepository } from '@/application/smallBusiness/domain/SmallBusinessRepository';
import { SmallBusinessPlanFilters } from '@/application/smallBusiness/domain/SmallBusinessPlanFilters';
import { SmallBusinessPlanResponse } from '@/planList/domain/SmallBusinessPlanResponse';

export class FetchAvailablePlansUseCase implements UseCase<SmallBusinessPlanFilters, SfApiResponse<SmallBusinessPlanResponse>> {

  private repository: SmallBusinessRepository;

  public constructor (repository: SmallBusinessRepository) {
    this.repository = repository;
  }

  public async run (filters: SmallBusinessPlanFilters): Promise<SfApiResponse<SmallBusinessPlanResponse>> {
    return await this.repository.fetchAvailablePlans(filters);
  }

}
